/**
 * The page's queue of picks waiting for the A&P to open their order forms (`frameV2`, 1 Oct).
 *
 * With the switch ON the A&P holds a pick while the plan has no diagnosis, so picks can wait here,
 * and a second one must queue behind the first rather than replace it (Codex P2). With the switch
 * OFF the page keeps its single slot: a new pick replaces, a consume empties.
 *
 * CONSUMPTION IS PER SEED, NOT "POP THE HEAD" (Codex, second pass). The A&P consumes from an
 * effect, and React StrictMode (on in `main.tsx`) runs a mount effect twice with the same props.
 * A bare pop would then remove the head AND the order queued behind it: open A, lose B. So the
 * consumer names the seed it consumed and a second consume of the same seed changes nothing.
 */
export function enqueueSeed<T>(prev: T[], seed: T, queue: boolean): T[] {
  return queue ? [...prev, seed] : [seed];
}

/** Remove `consumed` if it is still the head. Anything else is a replay or a stale call: no-op. */
export function consumeSeed<T>(prev: T[], consumed: T | null | undefined): T[] {
  return consumed != null && prev[0] === consumed ? prev.slice(1) : prev;
}
